import React from "react";

import { cn } from "../../../common/u1/cn";
import { PLAN_MONTHLY, PLAN_YEARLY } from "./membershipFields";

/* Yearly or monthly. A radiogroup rather than two buttons: it is one choice out of two, so arrow keys should move between them and a screen reader should say... */
const OPTIONS = [
  { id: PLAN_YEARLY, label: "Yearly", note: "Save ~16%" },
  { id: PLAN_MONTHLY, label: "Monthly" },
];

export const BillingCycleToggle = ({ value, onChange, className = "" }) => (
  <div
    role="radiogroup"
    aria-label="Billing cycle"
    className={cn(
      "grid grid-cols-2 gap-1 rounded-[12px] bg-[var(--field-inset)] p-1",
      className
    )}
  >
    {OPTIONS.map((option) => {
      const selected = value === option.id;
      return (
        <button
          key={option.id}
          type="button"
          role="radio"
          aria-checked={selected}
          onClick={() => onChange?.(option.id)}
          className={cn(
            "flex h-9 items-center justify-center gap-1.5 rounded-[9px] text-[13px]",
            "font-semibold font-sans transition-colors",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--orange)]",
            selected
              ? "bg-white text-[var(--ink)] shadow-[0_1px_2px_rgba(0,0,0,.08)]"
              : "bg-transparent text-[var(--muted)] hover:text-[var(--ink-2)]"
          )}
        >
          {option.label}
          {option.note && (
            <span
              className={cn(
                "rounded px-1.5 py-0.5 text-[9.5px] font-bold leading-none",
                "bg-[var(--coral-soft)] text-[var(--coral-deep)]"
              )}
            >
              {option.note}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default BillingCycleToggle;
